/** Wildfire burn pane — single forecast row (not separate burn taxa). */
export const BURN_MOREL_FORECAST_NAME = 'Burn Morels';
export const BURN_MOREL_FORECAST_SLUG = 'morels';

/** Dedicated field-guide route for the Burn Morels map pane (distinct from natural morels). */
export const BURN_MOREL_PANE_SLUG = 'burn-morels';

/** Field guide / map layer — hardwood-associated Morchella spp. (not burn morels). */
export const NATURAL_MOREL_SPECIES_NAME = 'Natural Morels';
export const NATURAL_MOREL_SPECIES_SLUG = 'morels';

/** GBIF M. brunnea — thumbnail for burn context (skip CMS genus/natural morel image). */
export const BURN_MOREL_FORECAST_IMAGE_TAXON_ID = 7397017;

/** Burn Morels is the species pane. The burns map layer is a separate toggle. */
export function speciesUsesWildfireBurnLayer(species: {
  slug?: string | null;
  name?: string | null;
  paneMapLegend?: string | null;
}): boolean {
  if (species.slug === BURN_MOREL_PANE_SLUG) return true;
  if (
    (species.name ?? "").trim().toLowerCase() ===
    BURN_MOREL_FORECAST_NAME.toLowerCase()
  ) {
    return true;
  }
  return species.paneMapLegend === "wildfire-burns";
}
